$(document).ready(function() {
	$.jsonp({
		url: $bookURL+'/util/checkDBConnection.page?callback=?',
		success: function(outage){
			console.log('Home page - outage check status = '+outage.status);
			switch(outage.status){
				case "success":
					$.getScript('/js/share/find/fnc.core.js',function(data, textStatus, jqxhr){
						type = "quick-search";
						$.getScript('/js/share/find/fnc.simple.home.js');
					}).fail(function(jqxhr, settings, exception){
							console.log(exception);
					});
					loadLastViewed();
					break;
				case "outage":
				case "error":  
				default:
					renderOutage();
					break;
			}
		},
		error: function(){ 
			console.log('Home page - outage check failed');	
			renderOutage();				
		}
	});				
	
	function loadPorts(){
		$.getJSON('/find/getEmbarkPortsJSON.do', function(data) {
			$.each(data, function(key, val) {
				$('#port').append('<option id="E'+key+'" value="'+key+'">'+val+'</option>');
			});
		});		
	}
	
	function loadLastViewed(){
		$.getJSON('/find/getLastViewedJSON.do', function(data) {
			if( data ){
				$('#last-viewed').attr('href','/find/cruiseDetails.do?itinCode='+data.ITIN_CODE+'&voyageCode='+data.VYG_CODE+'&resType='+data.RES_TYPE).find('p').text(data.NAME);
				if ($('.quick-link.alert').length == 0){
					$('#last-viewed').css('display','block');
				}
			}
			else{
				$('#last-viewed').remove();
			}	
		});			
	}
	
	function initBookingEngineDetails(){
		$.getJSON('/find/getBookingEngineDtlsJSON.do', function(data) {
			bookingEngineDetails = bookingEngineDetails + data.bookingEngineId + ',C,false,' + data.defaultSelectedMeta;
			console.log('bookingEngineDetails = ' + bookingEngineDetails);			
		});		
	}
	
	function renderOutage(){
		/*
		var jqxhr = $.get("./quickSearchOutage.html", function(data) { 
	     	$('#quick-search').empty();
	     	$('#quick-search').append(data);
	   	}, "html");				
		*/
		var searchUnavailable = $('#search-unavailable').html();
		$('#quick-search').find('fieldset').replaceWith(searchUnavailable);
	}		
		
});